// components/ComplianceArcImage.tsx
"use client";

import Image from "next/image";
import { Box } from "@mui/material";

export default function ComplianceArcImage({
    src,
    alt = "Compliance & Car Standards",
    ratio = "842 / 390",        // <- use your image’s native ratio    
    fit = "contain",
    rounded = false,
}) {
    return (
        <Box sx={{ mx: "auto", width: "100%" }}>
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    aspectRatio: ratio,
                    overflow: rounded ? "hidden" : "visible",
                    borderRadius: rounded ? 2 : 0,
                }}
            >
                <Image
                    src={src}
                    alt={alt}
                    fill
                    sizes="(max-width: 600px) 100vw, (max-width: 1200px) 80vw, 1100px"
                    style={{ objectFit: fit }}
                    priority
                />
            </Box>
        </Box>
    );
}
